/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export class ErrorTypes {
    public static BODY_INFO_APIGW_ERROR_C901: string = 'C901';

    public static BODY_INFO_BAD_REQUEST_C902: string = 'C902';

    public static BODY_INFO_INTERNAL_SERVER_ERROR_C903: string = 'C903';

    public static BODY_INFO_RESOURCE_NOT_FOUND_C904: string = 'C904';

    public static BODY_INFO_UNKNOWN_ERROR_C905: string = 'C905';

    public static BRANDING_APIGW_ERROR_C1401: string = 'C1401';

    public static BRANDING_BAD_REQUEST_C1402: string = 'C1402';

    public static BRANDING_INTERNAL_SERVER_ERROR_C1403: string = 'C1403';

    public static BRANDING_METHOD_NOT_ALLOWED_C1404: string = 'C1404';

    public static BRANDING_RESOURCE_NOT_FOUND_C1405: string = 'C1405';

    public static BRANDING_UNKNOWN_ERROR_C1499: string = 'C1499';

    public static DEVICE_FEATURES_SEARCH_APIGW_ERROR_C1002: string = 'C1002';

    public static DEVICE_FEATURES_SEARCH_UNKNOWN_ERROR_C1099: string = 'C1099';

    public static FILTERED_GUIDE_PROGRAMS_APIGW_4XX_C2201: string = 'C2201';

    public static FILTERED_GUIDE_PROGRAMS_APIGW_5XX_C2202: string = 'C2202';

    public static FILTERED_GUIDE_PROGRAMS_UNKNOWN_ERROR_C2299: string = 'C2299';

    public static TODO_LIST_APIGW_4XX_C2301: string = 'C2301';

    public static TODO_LIST_APIGW_5XX_C2302: string = 'C2302';

    public static TODO_LIST_UNKNOWN_ERROR_C2399: string = 'C2399';

    public static RECORDING_ACTIVITY_APIGW_4XX_C2401: string = 'C2401';

    public static RECORDING_ACTIVITY_APIGW_5XX_C2402: string = 'C2402';

    public static RECORDING_ACTIVITY_UNKNOWN_ERROR_C2499: string = 'C2499';

    public static GUIDE_CHANNELS_APIGW_401_C1101: string = 'C1101';

    public static GUIDE_CHANNELS_APIGW_4XX_C1102: string = 'C1102';

    public static GUIDE_CHANNELS_APIGW_5XX_C1103: string = 'C1103';

    public static GUIDE_CHANNELS_DYNAMODB_ERROR_C1104: string = 'C1104';

    public static GUIDE_CHANNELS_OBJECT_NOT_FOUND_C1105: string = 'C1105';

    public static GUIDE_CHANNELS_SERVICE_EMPTY_RESPONSE_C1106: string = 'C1106';

    public static GUIDE_CHANNELS_UNEXPECTED_ERROR_C1107: string = 'C1107';

    public static GUIDE_CHANNELS_BAD_REQUEST_C1108: string = 'C1108';

    public static GUIDE_CHANNELS_UNKNOWN_ERROR_C1199: string = 'C1199';

    public static GUIDE_ROWS_BAD_REQUEST_C1201: string = 'C1201';

    public static GUIDE_ROWS_DYNAMOBD_ERROR_C1202: string = 'C1202';

    public static GUIDE_ROWS_UNEXPECTED_ERROR_C1203: string = 'C1203';

    public static GUIDE_ROWS_UNKNOWN_ERROR_C1299: string = 'C1299';

    public static GUIDE_PREVIEW_APIGW_ERROR_C1301: string = 'C1301';

    public static GUIDE_PREVIEW_BAD_REQUEST_C1302: string = 'C1302';

    public static GUIDE_PREVIEW_INTERNAL_SERVER_ERROR_C1303: string = 'C1303';

    public static GUIDE_PREVIEW_APIGW_ERROR_C1304: string = 'C1304';

    public static GUIDE_PREVIEW_UNKNOWN_ERROR_C1399: string = 'C1399';

    public static LANGUAGE_NOT_SUPPORTED_OVERLAY_ERROR_D143: string = 'D143';

    public static LIVE_TV_CHANNEL_NOT_SUBSCRIBED_ERROR_CODE_V56: string = 'V56';

    public static LIVE_TV_DEVICE_ERROR_MISSING_CONFIG_V904: string = 'V904';

    public static LIVE_TV_LOCATION_RESTRICTION_OSD_ERROR_CODE_V418: string = 'V418';

    public static LIVE_TV_NOT_READY_FOR_PLAYBACK_V117: string = 'V117';

    public static LIVE_TV_IN_BLACKLIST_OSD_ERROR_C138: string = 'C138';

    public static LIVE_TV_GRACE_PERIOD_ENDED_ERROR_C718: string = 'C718';

    public static LIVE_TV_OOH_OSD_ERROR_V404: string = 'V404';

    public static LIVE_TV_OUT_OF_REGION_OSD_ERROR_V405: string = 'V405';

    public static LIVE_TV_PLAYLIST_URI_MISSING_V908: string = 'V908';

    public static LIVE_TV_SESSION_ERROR_AUTHENTICATION_EXPIRED_ERROR_V409: string = 'V409';

    public static LIVE_TV_SESSION_ERROR_BAD_ARGUMENT_V137: string = 'V137';

    public static LIVE_TV_SESSION_ERROR_INTERNAL_ERROR_V138: string = 'V138';

    public static LIVE_TV_AIRING_DATA_FAILED_V139: string = 'V139';

    public static LIVE_TV_SESSION_ERROR_NO_SESSION_V922: string = 'V922';

    public static LIVE_TV_SESSION_ERROR_NOT_AUTHENTICATED_V403: string = 'V403';

    public static LIVE_TV_SESSION_ERROR_NOT_AUTHORIZED_DEVICE_TYPE_V414: string = 'V414';

    public static LIVE_TV_LOCATION_ERROR_NOT_AUTHORIZED_OUT_OF_REGION_V418: string = 'V418';

    public static LIVE_TV_SESSION_ERROR_NOT_AUTHORIZED_V410: string = 'V410';

    public static LIVE_TV_SESSION_ERROR_NOT_REGISTERED_V406: string = 'V406';

    public static LIVE_TV_SESSION_ERROR_TOO_MANY_STREAMS_FOR_RESOURCE_ERROR_V408: string = 'V408';

    public static LIVE_TV_SESSION_ERROR_TOO_MANY_STREAMS_V407: string = 'V407';

    public static LIVE_TV_SESSION_ERROR_UNKNOWN_LOCATION_V405: string = 'V405';

    public static LIVE_TV_SESSION_ERROR_UNKNOWN_ERROR_V603: string = 'V603';

    public static LIVE_TV_UNSUPPORTED_CONTENT_ERROR_V950: string = 'V950';

    public static LIVE_TV_VPCONFIGURATIONS_EMPTY_RESPONSE_ERROR_V934: string = 'V934';

    public static LIVE_TV_VPCONFIGURATIONS_MISCONFIGURATION_ERROR_V909: string = 'V909';

    public static LIVE_TV_SHAKA_PLAYER_ENFORCEMENT_ERROR_V948: string = 'V948';

    public static LIVE_TV_SHAKA_PLAYER_NETWORK_ERROR_V951: string = 'V951';

    public static LIVE_TV_SHAKA_PLAYER_TEXT_ERROR_V952: string = 'V952';

    public static LIVE_TV_SHAKA_PLAYER_MEDIA_ERROR_V953: string = 'V953';

    public static LIVE_TV_SHAKA_PLAYER_MANIFEST_ERROR_V954: string = 'V954';

    public static LIVE_TV_SHAKA_PLAYER_STREAMING_MEDIA_V955: string = 'V955';

    public static LIVE_TV_SHAKA_PLAYER_DRM_ERROR_V956: string = 'V956';

    public static LIVE_TV_SHAKA_PLAYER_PLAYER_ERROR_V957: string = 'V957';

    public static LIVE_TV_SHAKA_PLAYER_CAST_ERROR_V958: string = 'V958';

    public static LIVE_TV_SHAKA_PLAYER_STORAGE_ERROR_V959: string = 'V959';

    public static LIVE_TV_SHAKA_PLAYER_ADS_ERROR_V960: string = 'V960';

    public static LIVE_TV_SHAKA_PLAYER_UNKNOWN_ERROR_V999: string = 'V999';

    public static MY_SHOWS_APIGATEWAY_ERROR_C1501: string = 'C1501';

    public static MY_SHOWS_BADREQUEST_ERROR_C1502: string = 'C1502';

    public static MY_SHOWS_RESOURCE_NOT_FOUND_ERROR_C1503: string = 'C1503';

    public static MY_SHOWS_INTERNAL_SERVER_ERROR_C1504: string = 'C1504';

    public static MY_SHOWS_NETWORK_DISCONNECTED_ERROR_C1505: string = 'C1505';

    public static MY_SHOWS_UNKNOWN_ERROR_C1599: string = 'C1599';

    public static MSO_DEFAULT_BRANDING_APIGW_ERROR_C201: string = 'C201';

    public static MSO_DEFAULT_BRANDING_BAD_REQUEST_C202: string = 'C202';

    public static MSO_DEFAULT_BRANDING_INTERNAL_SERVER_ERROR_C203: string = 'C203';

    public static MSO_DEFAULT_BRANDING_METHOD_NOT_ALLOWED_C204: string = 'C204';

    public static MSO_DEFAULT_BRANDING_RESOURCE_NOT_FOUND_C205: string = 'C205';

    public static MSO_DEFAULT_BRANDING_UNKNOWN_ERROR_C299: string = 'C299';

    public static MSO_SERVICE_ID_NOT_FOUND_C1001: string = 'C1001';

    public static NDVR_SESSION_ERROR_NOT_AUTHORIZED_V400: string = 'V400';

    public static NDVR_SESSION_ERROR_DEFAULT_V854: string = 'V854';

    public static NO_NETWORK_OVERLAY_ERROR_CODE: string = 'C145';

    public static OFFER_ACTION_APIGW_ERROR_V201: string = 'V201';

    public static OFFER_ACTION_BAD_REQUEST_ERROR_V202: string = 'V202';

    public static OFFER_ACTION_EMPTY_RESPONSE_ERROR_V203: string = 'V203';

    public static OFFER_ACTION_INTERNAL_SERVER_ERROR_V204: string = 'V204';

    public static OFFER_ACTION_UNEXPECTED_ERROR_V205: string = 'V205';

    public static OFFER_ACTION_UNKNOWN_ERROR_V299: string = 'V299';

    public static OTT_OFFER_ACTION_DETAILS_APIGW_ERROR_V301: string = 'V301';

    public static OTT_OFFER_ACTION_DETAILS_BAD_REQUEST_V302: string = 'V302';

    public static OTT_OFFER_ACTION_DETAILS_DATA_NOT_FOUND_V303: string = 'V303';

    public static OTT_OFFER_ACTION_DETAILS_DEVICE_INFO_NOT_FOUND_V304: string = 'V304';

    public static OTT_OFFER_ACTION_DETAILS_DYNAMO_DB_ERROR_V305: string = 'V305';

    public static OTT_OFFER_ACTION_DETAILS_EMPTY_RESPONSE_ERROR_V306: string = 'V306';

    public static OTT_OFFER_ACTION_DETAILS_INTERNAL_SERVER_ERROR_V307: string = 'V307';

    public static OTT_OFFER_ACTION_DETAILS_PARTNER_INFO_NOT_FOUND_V308: string = 'V308';

    public static OTT_OFFER_ACTION_DETAILS_UNEXPECTED_ERROR_V309: string = 'V309';

    public static OTT_OFFER_ACTION_DETAILS_UNKNOWN_ERROR_V399: string = 'V399';

    public static PC_CANNOT_COMPLETE_REQUEST_OVERLAY_ERROR_P103: string = 'P103';

    public static PC_TEMPORARY_PROBLEM_OVERLAY_ERROR_P102: string = 'P102';

    public static SIGN_IN_AUTH_SERVICE_BAD_REQUEST_C301: string = 'C301';

    public static SIGN_IN_AUTH_SERVICE_EMPTY_RESPONSE_C305: string = 'C305';

    public static SIGN_IN_AUTH_SERVICE_INTERNAL_SERVER_ERROR_C303: string = 'C303';

    public static SIGN_IN_AUTH_SERVICE_PARTIAL_RESPONSE_C304: string = 'C304';

    public static SIGN_IN_AUTH_SERVICE_RESOURCE_NOT_FOUND_C302: string = 'C302';

    public static SIGN_IN_AUTH_SERVICE_UNKNOWN_ERROR_C399: string = 'C399';

    public static SIGN_IN_IPTV_LOGIN_BAD_REQUEST_C601: string = 'C601';

    public static SIGN_IN_IPTV_LOGIN_EMPTY_RESPONSE_C610: string = 'C610';

    public static SIGN_IN_IPTV_LOGIN_EXPIRED_SAML_TOKEN_C602: string = 'C602';

    public static SIGN_IN_IPTV_LOGIN_INTEGRATION_TIMEOUT_C603: string = 'C603';

    public static SIGN_IN_IPTV_LOGIN_INTERNAL_SERVER_ERROR_C604: string = 'C604';

    public static SIGN_IN_IPTV_LOGIN_INVALID_SAML_TOKEN_C605: string = 'C605';

    public static SIGN_IN_IPTV_LOGIN_NOT_AUTHORIZED_C606: string = 'C606';

    public static SIGN_IN_IPTV_LOGIN_PARTIAL_RESPONSE_C609: string = 'C609';

    public static SIGN_IN_IPTV_LOGIN_RESOURCE_NOT_FOUND_C607: string = 'C607';

    public static SIGN_IN_IPTV_LOGIN_TOO_MANY_DEVICES_C608: string = 'C608';

    public static SIGN_IN_IPTV_LOGIN_UNKNOWN_ERROR_C699: string = 'C699';

    public static SIGN_IN_LICENSE_PLATE_DYNAMODB_ERROR_C501: string = 'C501';

    public static SIGN_IN_LICENSE_PLATE_EMPTY_RESPONSE_C506: string = 'C506';

    public static SIGN_IN_LICENSE_PLATE_GA_ERROR_C502: string = 'C502';

    public static SIGN_IN_LICENSE_PLATE_INTEGRATION_TIMEOUT_C503: string = 'C503';

    public static SIGN_IN_LICENSE_PLATE_PARTIAL_RESPONSE_C505: string = 'C505';

    public static SIGN_IN_LICENSE_PLATE_RESOURCE_NOT_FOUND_C504: string = 'C504';

    public static SIGN_IN_LICENSE_PLATE_UNKNOWN_ERROR_C599: string = 'C599';

    public static SIGN_IN_SAML_BAD_REQUEST_C401: string = 'C401';

    public static SIGN_IN_SAML_DEVICE_NOT_BOUND_C409: string = 'C409';

    public static SIGN_IN_SAML_EXPIRED_LICENSEPLATE_C404: string = 'C404';

    public static SIGN_IN_SAML_INVALID_LICENSEPLATE_C403: string = 'C403';

    public static SIGN_IN_SAML_INTEGRATION_TIMEOUT_C405: string = 'C405';

    public static SIGN_IN_SAML_INTERNAL_SERVER_ERROR_C406: string = 'C406';

    public static SIGN_IN_SAML_RESOURCE_NOT_FOUND_C402: string = 'C402';

    public static SIGN_IN_SAML_TOKEN_EMPTY_RESPONSE_C407: string = 'C407';

    public static SIGN_IN_SAML_TOKEN_PARTIAL_RESPONSE_C408: string = 'C408';

    public static SIGN_IN_SAML_TOKEN_REQUEST_NOT_ALLOWED_C410: string = 'C410';

    public static SIGN_IN_SAML_UNKNOWN_ERROR_C499: string = 'C499';

    public static SIGN_OUT_BAD_REQUEST_C701: string = 'C701';

    public static SIGN_OUT_INTERNAL_SERVER_C702: string = 'C702';

    public static SIGN_OUT_INTERNAL_TIMEOUT_C703: string = 'C703';

    public static SIGN_OUT_NOT_FOUND_C704: string = 'C704';

    public static SIGN_OUT_GA_ERROR_C705: string = 'C705';

    public static SIGN_OUT_NOT_AUTHORIZED_C706: string = 'C706';

    public static SIGN_OUT_DB_NOT_FOUND_TO_REMOVE_C707: string = 'C707';

    public static SIGN_OUT_UNKNOWN_C799: string = 'C799';

    public static SLS_API_GATEWAY_ERROR_C151: string = 'C151';

    public static SLS_EMPTY_RESPONSE_C156: string = 'C156';

    public static SLS_INVALID_REQUEST_ERROR_C152: string = 'C152';

    public static SLS_NOT_FOUND_ERROR_C153: string = 'C153';

    public static SLS_PARTIAL_RESPONSE_C155: string = 'C155';

    public static SLS_UNKNOWN_ERROR_C154: string = 'C154';

    public static SLS_SE_API_GW_ERROR_C801: string = 'C801';

    public static SLS_SE_EMPTY_RESPONSE_C806: string = 'C806';

    public static SLS_SE_INVALID_REQUEST_C802: string = 'C802';

    public static SLS_SE_NOT_FOUND_C803: string = 'C803';

    public static SLS_SE_PARTIAL_RESPONSE_C805: string = 'C805';

    public static SLS_SE_UNKNOWN_C804: string = 'C804';

    public static SOCU_OFFER_PARTNER_ID_ERROR_V393: string = 'V393';

    public static SOCU_PROVIDER_NOT_FOUND_V290: string = 'V290';

    public static SOS_MESSAGE_CODE_H111: string = 'H111';

    public static SOS_MESSAGE_CODE_H113: string = 'H113';

    public static UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_ERROR_C1601: string = 'C1601';

    public static UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_ERROR_C1602: string = 'C1602';

    public static UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_ERROR_C1603: string = 'C1603';

    public static UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_ERROR_C1604: string = 'C1604';

    public static UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_ERROR_C1699: string = 'C1699';

    public static VOD_BROWSE_TECHNICAL_ERROR_V1400: string = 'V1400';

    public static VOD_PLAY_ACTION_CANNOT_INITIATE_PROCESS_V431: string = 'V431';

    public static VOD_PLAY_ACTION_PROGRAM_UNAVAILABLE_V433: string = 'V433';

    public static VOD_PLAY_ACTION_PROGRAM_UNKNOWN_ENTITLEMENT_V432: string = 'V432';

    public static VOD_PLAY_ACTION_PURCHASE_FAILED_V361: string = 'V361';

    public static VOD_PLAY_ACTION_RENTALS_NOT_ALLOWED_V233: string = 'V233';

    public static GALLERY_SCREEN_ERROR_RESPONSE_C1700: string = 'C1700';

    public static RECORDING_CONTENT_SCREEN_DETAILS_1801: string = 'C1801';

    public static RECORDING_CONTENT_SCREEN_DETAILS_1802: string = 'C1802';

    public static RECORDING_CONTENT_SCREEN_DETAILS_1803: string = 'C1803';

    public static RECORDING_CONTENT_SCREEN_DETAILS_1804: string = 'C1804';

    public static RECORDING_CONTENT_SCREEN_DETAILS_1899: string = 'C1899';

    public static CONTENT_SCREEN_DETAILS_1901: string = 'C1901';

    public static CONTENT_SCREEN_DETAILS_1902: string = 'C1902';

    public static CONTENT_SCREEN_DETAILS_1903: string = 'C1903';

    public static CONTENT_SCREEN_DETAILS_1904: string = 'C1904';

    public static CONTENT_SCREEN_DETAILS_1999: string = 'C1999';

    public static OFFER_CONTENT_SCREEN_DETAILS_2001: string = 'C2001';

    public static OFFER_CONTENT_SCREEN_DETAILS_2002: string = 'C2002';

    public static OFFER_CONTENT_SCREEN_DETAILS_2003: string = 'C2003';

    public static OFFER_CONTENT_SCREEN_DETAILS_2004: string = 'C2004';

    public static OFFER_CONTENT_SCREEN_DETAILS_2099: string = 'C2099';

    public static VOD_OFFER_CONTENT_SCREEN_DETAILS_2101: string = 'C2101';

    public static VOD_OFFER_CONTENT_SCREEN_DETAILS_2202: string = 'C2202';

    public static VOD_OFFER_CONTENT_SCREEN_DETAILS_2203: string = 'C2203';

    public static VOD_OFFER_CONTENT_SCREEN_DETAILS_2204: string = 'C2204';

    public static VOD_OFFER_CONTENT_SCREEN_DETAILS_2299: string = 'C2299';

    public static JUMP_CHANNEL_UNAVAILABLE_V347: string = 'V347';

    public static EPISODE_GUIDE_APIGW_ERROR_C1501: string = 'C1501';

    public static EPISODE_GUIDE_BAD_REQUEST_C1502: string = 'C1502';

    public static EPISODE_GUIDE_RESOURCE_NOT_FOUND_C1503: string = 'C1503';

    public static EPISODE_GUIDE_INTERNAL_SERVER_ERROR_C1504: string = 'C1504';

    public static EPISODE_GUIDE_UNKNOWN_ERROR_C1599: string = 'C1599';
}
